var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"access-groups-form"},[_c('OurGroup',[_c('OurInput',{attrs:{"label":_vm.$t('page.catalog.name'),"placeholder":_vm.$t('placeholder.baseKnowledgeName'),"error":_vm.nameError},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }